import React, { forwardRef } from 'react';
import { motion } from 'framer-motion';

const pageVariant = {
  initial: {
    opacity: 1
  },
  animate: {
    opacity: 1,
    transition: {
      duration: 0.5
    }
  },
  exit: {
    opacity: 0,
    transition: {
      duration: 0.5
    }
  }
}

const AnimatedPage = forwardRef(({ children }, ref) => {
  return (
    <motion.div
      ref={ref}
      variants={pageVariant}
      initial="initial"
      animate="animate"
      exit="exit"
      className="page d-flex flex-column"
    >
      {children}
    </motion.div>
  )
});

export default AnimatedPage;